import * as React from "react";
import PageLayout from "../../components/Shared/PageLayout";
import { EDPageLoader, EEDAnimation, IEDPageParallaxBackgroundImage } from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";
import { grey } from "@mui/material/colors";

const PublicProfile = dynamic(() => import("../../components/Pages/PublicProfile/Public"), {
    suspense: false,
    ssr: false,
    loading: () => <EDPageLoader in={true} />,
})

export default function PublicProfilePage() {
    return <PublicProfile />
}

PublicProfilePage.metaData = {
    title: 'Eternal Dragons - Your Player Profile and Stats',
    description: 'Access your player profile in Eternal Dragons. Track your progress, view achievements, and analyze your battle stats. Take command and reign supreme!'  
}